export default __webpack_public_path__ + "static/media/governanca.15eb72a8.svg";